const services = [
    {
        category: "Web & App Development",
        items: [
            "Custom Website Design & Development",
            "Full-Stack Web Applications",
            "Mobile-Responsive Design",
            "SPA & Progressive Web Apps"
        ]
    },
    {
        category: "IT Consulting & Infrastructure",
        items: [
            "System Architecture & Administration",
            "Cloud Migration & Management",
            "IT Security & Data Protection",
            "Technical Support & Maintenance"
        ]
    },
    {
        category: "Data & Integration",
        items: [
            "Database Design & Optimization",
            "API Development & Integration",
            "Performance Optimization",
            "CI/CD & DevOps Pipelines"
        ]
    },
    {
        category: "IoT & Automation",
        items: [
            "Smart Home Device Integration",
            "IoT Solutions Development",
            "Home Automation System Design",
            "Industrial IoT Solutions"
        ]
    },
    {
        category: "AI & Machine Learning",
        items: [
            "AI Strategy & Consulting",
            "Machine Learning Integration",
            "AI-Powered Automation",
            "Natural Language Processing Solutions"
        ]
    }
];

export default function Services() {
    return (
        <section className="section">
            <span className="section-label">Services</span>
            <h2>Everything IT — so you can forget about it</h2>
            <p className="section-desc">
                From web apps to infrastructure, we cover the full spectrum of technology so you never have to worry about the details.
            </p>

            <div className="card-grid cols-5">
                {services.map((service, i) => (
                    <div className="card-item" key={i} data-aos="fade-up" data-aos-delay={i * 100}>
                        <h3>{service.category}</h3>
                        <ul>
                            {service.items.map((item, j) => (
                                <li key={j}>{item}</li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>
        </section>
    );
}
